import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
  ImmomioIconName,
  PaymentRequestCardBaseComponent,
  PaymentRequestStatus,
  PaymentStatusBgPipe,
} from '@resident-nx/shared';
import { TranslateModule } from '@ngx-translate/core';
import { CurrencyPipe, DatePipe, NgClass, UpperCasePipe } from '@angular/common';
import { ElevationDirective, IconWebComponent } from '@resident-nx/web/ui';

@Component({
  standalone: true,
  selector: 'rs-web-payment-request-card',
  templateUrl: './payment-request-card.component.html',
  styleUrls: ['./payment-request-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ElevationDirective,
    NgClass,
    UpperCasePipe,
    CurrencyPipe,
    DatePipe,
    TranslateModule,
    PaymentStatusBgPipe,
    IconWebComponent,
  ],
})
export class PaymentRequestCardWebComponent extends PaymentRequestCardBaseComponent {
  public paymentStatus = PaymentRequestStatus;
  protected readonly ImmomioIconName = ImmomioIconName;

  public isOverdue(status: PaymentRequestStatus): boolean {
    return status === this.paymentStatus.OVERDUE;
  }

  public isPaid(status: PaymentRequestStatus): boolean {
    return status === this.paymentStatus.PAID;
  }

  public isError(status: PaymentRequestStatus): boolean {
    return status === this.paymentStatus.ERROR;
  }

  public isWaitingForPayment(status: PaymentRequestStatus): boolean {
    return status === this.paymentStatus.CHECK_MANUALLY;
  }

  public isCanceled(status: PaymentRequestStatus): boolean {
    return status === this.paymentStatus.CANCELED;
  }

  public openPaymentRequestPage(url: string) {
    window.open(url, '_blank');
  }

  public getIcon(status: PaymentRequestStatus): ImmomioIconName {
    if (status === this.paymentStatus.ERROR) {
      return ImmomioIconName.Warning;
    }
    if (
      status === this.paymentStatus.PAID ||
      status === this.paymentStatus.CANCELED ||
      status === this.paymentStatus.PAID_OUT ||
      status === this.paymentStatus.REFUNDED
    ) {
      return ImmomioIconName.Archive;
    }
    return ImmomioIconName.MoneyPig;
  }
}
